import React from 'react';
import './Tbc-Header-Text.css';

const tbcHeaderText = (props) => {
    return <h1 className="tbc-header-text text-center">{props.children}</h1>;
};
export default tbcHeaderText;